import { useIsTablet } from 'src/hooks/use-is-mobile';
import { imageOptimize } from 'src/service/image';
import { useState, useEffect } from 'react';
import categories from 'src/configs/categories';
import { fetchExplore } from 'src/app/explore/service';
import Link from 'next/link';

const MultiTribe = ({ data }: { data: any[] }) => {
  const isMobile = useIsTablet();

  const [tribeList, setTribeList] = useState<any[]>([]);
  const [defList, setDefTribeList] = useState<any[]>([]);

  useEffect(() => {
    const tribeData = data.map((d) => {
      if (categories.filter((e) => e.value === d.tribe_name).length > 0) {
        return {
          title: d.tribe_name,
          image_url: '',
          count: 0,
          isCategory: true,
        };
      }
      return {
        title: d.tribe_name,
        image_url: d.banner_image_url,
        count: 0,
        isCategory: false,
      };
    });
    setTribeList(tribeData);
    setDefTribeList(tribeData);
  }, []);

  const getDataList = (dataList) => {
    let listData = '';
    dataList.forEach((sid, sidx) => {
      if (sidx > 0) {
        listData += `&name=${sid.title}`;
      } else {
        listData += `name=${sid.title}`;
      }
    });
    return listData;
  };

  const mapCount = (defData, newData) => {
    defData.forEach((e) => {
      newData.forEach((s) => {
        if (s.name === e.title) {
          e.count = s.count;
        }
      });
    });
  };

  useEffect(() => {
    const getCategories = async () => {
      const newTribeList = [...tribeList];
      // const catData = newTribeList.filter((e) => e.isCategory);
      const tagData = newTribeList.filter((e) => !e.isCategory);
      const fetchedCat = await fetchExplore({
        type: 'category',
      });
      const fetchedTag = await fetchExplore({
        type: 'tag',
        data: getDataList(tagData),
      });
      mapCount(newTribeList, fetchedCat);
      mapCount(newTribeList, fetchedTag);
      setTribeList(newTribeList);
    };

    if (defList?.length > 0) {
      getCategories();
    }
  }, [defList]);

  return (
    <>
      <div style={{ maxWidth: '63rem' }} className="h-full mx-auto w-auto">
        {isMobile ? (
          <div className="flex mx-2.5">
            {tribeList?.map((d, key) => {
              const mkey = `ca_${key}`;
              return (
                <div style={{ margin: '0 10px' }}>
                  <TribeItems key={mkey} itemData={d} />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="grid gap-12 grid-cols-3">
            {tribeList?.map((d, key) => {
              const mkey = `ca_${key}`;
              return <TribeItems key={mkey} itemData={d} />;
            })}
          </div>
        )}
      </div>
    </>
  );
};
export default MultiTribe;

const TribeItems = ({ itemData }: { itemData?: any }) => {
  const isMobile = useIsTablet();

  const getBGImage = () => {
    if (itemData?.isCategory) {
      return `url(/images/assets/categories/${itemData.title
        .replace(' & ', '')
        .replace(/\s/g, '')}.png`;
    }
    return `url(${imageOptimize(itemData?.image_url)})`;
  };

  const getPath = (data) => {
    return data?.replace(/ /g, '-');
  };

  return (
    <Link prefetch={false} href={`/agora/${getPath(itemData?.title)}`}>
      <div
        style={{
          backgroundImage: getBGImage(),
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundColor: '#00000005',
          backgroundBlendMode: 'multiply',
          width: `${isMobile ? '252px' : '306px'}`,
          height: `${isMobile ? '193px' : '209px'}`,
        }}
        className="rounded-3xl overflow-hidden bg-gray-500 relative p-6 cursor-pointer text-white"
      >
        <div className="absolute bottom-10">
          <div className="text-xl pb-3 font-semibold">
            {!itemData?.isCategory && '#'}
            {itemData?.title}
          </div>
          <div className="text-sm md:text-base">
            <span className="font-bold pr-1">{itemData?.count}</span>
            creations
          </div>
        </div>
      </div>
    </Link>
  );
};
